var map = {
	"./d1-active.png": "5d94",
	"./d1.png": "4d4d",
	"./d2-active.png": "6969",
	"./d2.png": "c139",
	"./d3-active.png": "f561",
	"./d3.png": "05dc",
	"./d4-active.png": "65f2",
	"./d4.png": "b974",
	"./d5-active.png": "2e6d",
	"./d5.png": "d54b",
	"./d6-active.png": "e37e",
	"./d6.png": "d049"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0756";